export default {
  init() {

    setTimeout(function() {
        activitySingleImgPlace();
    }, 500);


    $('.js-activity-register-jumplink').on('click', function() {
      singleActivityJumpLink();
    });

  },
  finalize() {

    $(window).resize(function() {
        activitySingleImgPlace();
    });

  },
};

function activitySingleImgPlace() {
    if ( $('.js-activity-single-img').length ) {
        var size = $('.js-activity-single-img').height() / 3 * 2;
        $('.js-activity-single-img').css('margin-bottom', '-' + size + 'px');
        $('.js-activity-single-content').css('padding-top', size + 'px');
    }
}

function singleActivityJumpLink() {
    document.querySelector('.js-activity-register').scrollIntoView({ 
      behavior: 'smooth',
      block: 'start',
    });
}


// WEBPACK FOOTER //
// ./scripts/routes/single-activity.js